export default function Categories() {
  const categories = [
    {
      icon: 'ri-run-line',
      title: '과학적 분석 시스템',
      description: `신체 활동·사고 과정·태도 변화를 종합적으로 분석하여 아이의 발달 흐름을 체계적으로 관리합니다.`,
      color: 'bg-orange-500',
      image: 'https://public.readdy.ai/ai/img_res/da979c5f1eb776e85e5daca743f00ae7.jpg'
    },
    {
      icon: 'ri-puzzle-line',
      title: '창의융합놀이 프로그램',
      description: `신체 활동과 사고 과제를 결합해 유창성·융통성·문제해결력을 함께 키우는 핵심 커리큘럼입니다.`,
      color: 'bg-yellow-500',
      image: 'https://readdy.ai/api/search-image?query=Children%20playing%20with%20educational%20toys%20and%20puzzles%20in%20a%20creative%20learning%20space%2C%20colorful%20play%20equipment%2C%20kids%20collaborating%20together%2C%20bright%20yellow%20and%20orange%20tones%2C%20simple%20clean%20background%2C%20engaging%20learning%20environment&width=600&height=400&seq=cat-002&orientation=landscape'
    },
    {
      icon: 'ri-basketball-line',
      title: '기본움직임 기술 프로그램',
      description: `이동·균형·조작 능력을 중심으로 모든 학습의 기초가 되는 신체 역량을 체계적으로 설계합니다.`,
      color: 'bg-green-500',
      image: 'https://readdy.ai/api/search-image?query=Children%20playing%20sports%20and%20ball%20games%20in%20an%20indoor%20sports%20facility%2C%20kids%20with%20basketballs%20and%20sports%20equipment%2C%20active%20and%20healthy%20lifestyle%2C%20green%20and%20orange%20color%20scheme%2C%20simple%20clean%20background%2C%20professional%20sports%20training%20atmosphere&width=600&height=400&seq=cat-003&orientation=landscape'
    },
    {
      icon: 'ri-parent-line',
      title: '기능성 발달 트레이닝 프로그램',
      description: `연령과 발달 수준에 맞춘 움직임 설계로 신체 사용 능력과 조절 능력을 함께 향상시킵니다.`,
      color: 'bg-pink-500',
      image: 'https://readdy.ai/api/search-image?query=Children%20doing%20physical%20training%20exercises%20in%20a%20modern%20sports%20center%2C%20kids%20stretching%20and%20doing%20movement%20activities%20with%20instructor%20guidance%2C%20active%20body%20development%20training%2C%20warm%20pink%20and%20orange%20tones%2C%20simple%20clean%20background%2C%20professional%20training%20environment%20with%20soft%20lighting&width=600&height=400&seq=cat-004-physical&orientation=landscape'
    },
    {
      icon: 'ri-star-line',
      title: 'AR증강현실 교육프로그램',
      description: `디지털 환경과 신체 활동을 결합해 몰입도 높은 학습 경험과 사고 확장을 동시에 설계합니다.`,
      color: 'bg-purple-500',
      image: 'https://public.readdy.ai/ai/img_res/edited_02d9dfdf0ab708dad1ebb4f352edbfc9_03b3fcbe.jpg'
    },
    {
      icon: 'ri-user-star-line',
      title: '개인맞춤형 프로그램',
      description: `아이의 발달 특성과 성향을 분석해 1:1 또는 소그룹 맞춤형 교육으로 성장을 정밀하게 지원합니다.`,
      color: 'bg-teal-500',
      image: 'https://readdy.ai/api/search-image?query=One-on-one%20personalized%20training%20session%20with%20child%20and%20instructor%20in%20a%20modern%20sports%20center%2C%20individual%20attention%20and%20customized%20learning%2C%20teal%20and%20orange%20color%20scheme%2C%20simple%20clean%20background%2C%20focused%20and%20supportive%20teaching%20environment&width=600&height=400&seq=cat-006&orientation=landscape'
    }
  ];

  return (
    <section id="categories" className="py-12 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            공통 핵심 교육 프로그램
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            아이의 발달 단계에 맞춰, 신체·사고·태도를 함께 설계하는 창의융합 교육 시스템
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((category, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-40 md:h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-3 right-3 md:top-4 md:right-4 w-10 h-10 md:w-12 md:h-12 ${category.color} rounded-full flex items-center justify-center shadow-lg`}>
                  <i className={`${category.icon} text-xl md:text-2xl text-white`}></i>
                </div>
              </div>
              
              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{category.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{category.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
